import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

import type { FlowChatGetAllPayloadT } from '../api/types';

export const chatFlowsActions = createActions(
  {
    CHAT_FLOWS_GET_ALL: [
      (payload: FlowChatGetAllPayloadT) => payload, // Payload
      (_payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
  },
  'CHAT_FLOWS_GET_ALL_SUCCEEDED',
  'CHAT_FLOWS_GET_ALL_FAILED',
);
